import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { MPTEntity } from "../../../Data/MedicinalProductData/MPTEntity";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeMPTEntity extends BaseNode {

    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any) {
        super(injector, new MPTEntity(injector,model), labelTemplate);
        this.parent=parent;
        this.ioc!.get(Art57Section).generateNumColumValue(this);
    }

    public getListItem(): any[] {
        return [this.data.model.producttypecode.name];
    }

    override cloneNode(newParent: BaseNode): BaseNode {
      let clonedNode: TreeNodeMPTEntity = new TreeNodeMPTEntity(
        this.ioc!,
        this.labelTemplate,
        newParent,
        this.data.model
      );
  
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

// property doesn't exist      clonedNode.cloningNode = false;
      return clonedNode;
    }

}